module.exports = __webpack_public_path__ + "static/media/SO_Overview.d62dae4d.jpg";